import moment from "moment";
import React from "react";
import { CommonTooltipType } from "../../types/common.type";

interface NewsHeadlineProps {
  nid: string;
  headline?: string;
  date?: string;
  time?: string;
  callback?: any;
  onPaneSwitch?: (type: string) => void;
  isSmallScreen?: boolean;
  setRef?: any;
  touch: boolean;
  setTooltip: (tooltip: any) => void;
  tooltipRef: React.RefObject<HTMLDivElement>;
}
const NewsHeadline = ({
  nid,
  headline,
  date,
  time,
  callback,
  onPaneSwitch,
  isSmallScreen,
  setRef,
  touch,
  setTooltip,
  tooltipRef,
}: NewsHeadlineProps) => {

  const constrainTooltipPosition = (e: React.MouseEvent) => {
    // Estimate tooltip dimensions (these are approximate values from CSS)
    // Calculate initial position based on item position and mouse offset
    let x = e.pageX + 10
    let y = e.pageY

    const elementMaxWidth = tooltipRef.current?.clientWidth || 0;
    const elementMaxHeight = tooltipRef.current?.clientHeight || 0;
    const scrollX = window.pageXOffset || document.documentElement.scrollLeft;
    const scrollY = window.pageYOffset || document.documentElement.scrollTop;
    const viewportWidth = window.innerWidth + scrollX;
    const viewportHeight = window.innerHeight + scrollY;

    if (x + elementMaxWidth > viewportWidth) {
      x = x - elementMaxWidth;
    }
    if (y + elementMaxHeight > viewportHeight) {
      y = y - elementMaxHeight;
    }

    return { x, y };
  };

  function onClickHandler(
    evt: React.MouseEvent<HTMLButtonElement, MouseEvent>
  ) {
    if (callback) {
      callback(nid);
    }
  }

  return (
    <button
      ref={setRef}
      className="news-headline"
      aria-label={headline}
      onClick={onClickHandler}
    >
      <div className="news-headline-container">
        <div className="headline" onMouseEnter={(e) => {
          if (touch) return;
          const constrainedPosition = constrainTooltipPosition(e);
          setTooltip({
            show: true,
            x: constrainedPosition.x,
            y: constrainedPosition.y,
            content: headline
          });
        }}
          onMouseMove={(e) => {
            //if no move, do not update tooltip
            if ((e.movementX === 0 && e.movementY === 0) || touch) {
              return;
            }
            const constrainedPosition = constrainTooltipPosition(e);
            setTooltip((prev: any) => ({
              ...prev,
              x: constrainedPosition.x,
              y: constrainedPosition.y
            }));
          }}
          onMouseLeave={() => {
            if (touch) return;
            setTooltip((prev: any) => ({ ...prev, show: false }));
          }}
          onMouseOut={() => {
            if (touch) return;
            setTooltip((prev: any) => ({ ...prev, show: false }));
          }}>{headline}</div>
      </div>
      <div className="datetime">{`${moment(date).format("DD MMM")} ${time}`}</div>
    </button>
  );
};

export default NewsHeadline;
